import { Card, Col, Flex, Row, Statistic, Typography } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  FallOutlined,
  InfoCircleOutlined,
  RiseOutlined,
  MonitorOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";

const { Text, Title } = Typography;

const Rise = () => (
  <RiseOutlined style={{ color: "var(--ant-color-success)", marginRight: 6 }} />
);

const Drop = () => (
  <FallOutlined style={{ color: "var(--ant-color-error)", marginRight: 6 }} />
);

function PowerFactorHighlightCard({ currentValue = 0, lastValue = 0 }) {
  const numberFormat = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

  return (
    <Card
      size="small"
      bordered
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      {/* <PercentageOutlined
        style={{
          position: "absolute",
          right: 24,
          top: 18,
          fontSize: 48,
          color: "var(--ant-cyan)",
        }}
      /> */}
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex justify="start" align="end" gap={8}>
            <Statistic
              title={
                <Title level={5} style={{ margin: 0, marginBottom: 8 }}>
                  Power Factor
                </Title>
              }
              valueStyle={{
                fontSize: "var(--ant-font-size-heading-2)",
                fontWeight: "var(--ant-font-weight-strong)",
              }}
              value={currentValue}
              precision={2}
              formatter={(value) => (
                <CountUp
                  end={value}
                  separator=","
                  duration={1.5}
                  decimals={2}
                />
              )}
            ></Statistic>
          </Flex>
          <Flex justify="start" align="center" gap={4}>
            {currentValue > lastValue ? <Rise /> : <Drop />}
            <Text>{lastValue?.toLocaleString("en-US", numberFormat)}</Text>
            <Text type="secondary">Last Month (To-Date)</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
    // <Card
    //   title={
    //     <Title level={5} style={{ margin: 0 }}>
    //       <MonitorOutlined style={{ marginRight: 12 }} />
    //       Power Factor
    //     </Title>
    //   }
    //   size="small"
    //   bordered
    // >
    //   <Row gutter={[12, 12]}>
    //     <Col span={24}>
    //       <Flex justify="start" align="end" gap={8}>
    //         <Title level={2} style={{ margin: 0 }}>
    //           {currentValue
    //             ? currentValue.toLocaleString("en-US", numberFormat)
    //             : currentValue === 0
    //             ? currentValue
    //             : " - "}
    //         </Title>
    //       </Flex>
    //     </Col>
    //     {/* <Col span={24}>
    //                 <Flex justify='end' align='center' gap={8}>
    //                     <Title level={4} style={{ margin: 0 }} type={ currentValue > lastValue ? 'success' : 'danger'}> {lastValue > currentValue ? <FallOutlined /> : <RiseOutlined />}
    //                     </Title>
    //                     <Text italic>Last : { lastValue? lastValue.toLocaleString("en-US", numberFormat) + ' ' : " - "}
    //                     ( {
    //                         currentValue? lastValue? ((currentValue - lastValue) / lastValue).toLocaleString('en-US', { maximumFractionDigits: 1, style: 'percent' }) : ' - %': ' - %'
    //                     } )
    //                     </Text>
    //                 </Flex>
    //             </Col> */}
    //   </Row>
    // </Card>
  );
}

export default PowerFactorHighlightCard;
